import React, { useState } from "react";
import {
  Avatar,
  Button,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Typography,
} from "@material-tailwind/react";
import {
  DocumentIcon,
  PowerIcon,
  UserCircleIcon,
  Cog8ToothIcon,
} from "@heroicons/react/24/solid";
import { useRouter } from "next/navigation";
import { TUser } from "@/features/profile/types";
import userApi from "@/api/user";
import { userState } from "@/features/profile/service";
import authService from "@/features/auth/services";

// profile menu component
const profileMenuItems = [
  {
    key: "profile",
    label: "ข้อมูลของฉัน",
    icon: UserCircleIcon,
  },
  {
    key: "doc",
    label: "เอกสาร",
    icon: DocumentIcon,
  },
  {
    key: "reset-password",
    label: "แก้ไขรหัสผ่าน",
    icon: Cog8ToothIcon,
  },
  // {
  //     label: "Inbox",
  //     icon: InboxArrowDownIcon,
  // },
  // {
  //     label: "Help",
  //     icon: LifebuoyIcon,
  // },
  {
    key: "signout",
    label: "ออกจากระบบ",
    icon: PowerIcon,
  },
];

interface Props {
  user: TUser;
}

export function AvatarWithUserDropdown({ user }: Props) {
  const router = useRouter();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const closeMenu = (key: string) => {
    switch (key) {
      case "signout":
        return signout();
      case "profile":
        return router.push("/profile");
      case "doc":
        return router.push("/docs");
      case "reset-password":
        return router.push("/user/reset-password");
      default:
        setIsMenuOpen(false);
        break;
    }
  };

  const signout = async () => {
    try {
      setIsLoading(true);
      await userApi.signout();
      userState.setState(null);
      authService.removeIsLoggedIn();
    } catch (error) {
    } finally {
      router.replace("/");
      setIsLoading(false);
    }
  };

  return (
    <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
      <MenuHandler>
        <Button
          variant="text"
          color="blue-gray"
          className="flex items-center rounded-full p-0 bg-[#188F46]"
          name="user-menu-toggle"
          aria-label={`เมนูผู้ใช้ - ${user.firstName || user.email || "สมาชิก"}`}
        >
          <Avatar
            variant="circular"
            size="md"
            alt="user"
            withBorder={true}
            color="blue-gray"
            className="p-0.5"
            src={user.avatarUrl ? user.avatarUrl : "/image/pastel_gradient.jpg"}
          />
        </Button>
      </MenuHandler>
      <MenuList className="p-1 font-noto">
        {profileMenuItems.map(({ key, label, icon }, index) => {
          const isLastItem = index === profileMenuItems.length - 1;
          return (
            <MenuItem
              key={label}
              onClick={() => closeMenu(key)}
              className={`flex items-center gap-2 rounded ${
                isLastItem
                  ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                  : ""
              }`}
              disabled={isLoading}
            >
              {React.createElement(icon, {
                className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
                strokeWidth: 2,
              })}
              <Typography
                as="span"
                variant="small"
                className="font-normal font-noto"
                color={isLastItem ? "red" : "inherit"}
              >
                {label}
              </Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}
